export default {
  bind(el, binding, vnode) {
    if (typeof binding.value !== 'function') {
      const compName = vnode.context.name
      let warn = `В директиве [clickoutside:] выражение '${binding.expression}' должно быть функцией`
      if (compName) {
        warn += ` Найдено в компоненте '${compName}'`
      }
      // eslint-disable-next-line no-console
      console.$swarn(warn)
    }
    el.__clickOutsideHandler__ = (e) => {
      if (binding.modifiers.bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    document.addEventListener('click', el.__clickOutsideHandler__, true)
  },
  unbind(el) {
    document.removeEventListener('click', el.__clickOutsideHandler__, true)
    el.__clickOutsideHandler__ = null
  }
}